<script setup>

import IndexLayout from "@/Layouts/IndexLayout.vue";
import Card from "@/Components/Card.vue";
import AkLogo from "@/Components/Icons/AkLogo.vue";
import {usePage} from "@inertiajs/vue3";

const page = usePage();
</script>

<template>
    <IndexLayout :title="page.props.page.title">
        <div class="flex justify-center items-center m-auto max-w-[48.75rem] w-full pt-2.5 px-2.5 lg:px-0">
            <Card class="flex flex-col gap-2.5 p-5 w-full">
                <div class="p-2 flex gap-5 bg-slate-100 dark:bg-deep-blue items-center">
                    <div class="p-2 bg-white dark:bg-dark-blue">
                        <AkLogo class="w-15"/>
                    </div>
                    <div>
                        <h1 class="dark:text-slate-200 font-['Unbounded'] text-base lg:text-xl font-medium leading-120">
                            {{ page.props.page.title }}
                        </h1>
                    </div>
                </div>
                <div class="dark:text-slate-200" v-html="page.props.page.content"></div>
                <div class="p-2">
                    <div class="p-1 bg-slate-100 dark:bg-dark-blue w-max">
                        <AkLogo class="w-7"/>
                    </div>
                </div>
            </Card>
        </div>
    </IndexLayout>
</template>

<style scoped>

</style>
